import { useEffect, useState } from 'react';
import { motion, useSpring } from 'framer-motion';

/**
 * ScrollProgressBar — a fixed, top-edge bar that fills as the user scrolls.
 * Uses a spring for a smooth, slightly elastic feel.
 */
const ScrollProgressBar = () => {
  const [progress, setProgress] = useState(0);
  const spring = useSpring(progress, { stiffness: 180, damping: 30 });

  useEffect(() => {
    const onScroll = () => {
      const doc = document.documentElement;
      const scrollTop = window.scrollY || doc.scrollTop;
      const scrollHeight = doc.scrollHeight - doc.clientHeight;
      const pct = scrollHeight > 0 ? scrollTop / scrollHeight : 0;
      setProgress(pct);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    spring.set(progress);
  }, [progress, spring]);

  return (
    <motion.div
      className="scroll-progress-bar"
      style={{ scaleX: spring, transformOrigin: 'left' }}
    />
  );
};

export default ScrollProgressBar;
